import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';
import { tryParseJson } from '@jbhi-fi/utils/src/JSON/tryParseJson';
import { ServiceOffering } from '@jbhi-fi/apis/src/services/types';

export const transformCartItemForTracking = (item: Record<string, any>): EcommerceCartItem | undefined => {
  let gtmProduct = item?.properties?.['_gtmProduct'] ? tryParseJson<any>(item?.properties['_gtmProduct']) : undefined;
  if (!gtmProduct) {
    if (item?.properties?.['_serviceData']) {
      gtmProduct = tryParseJson<ServiceOffering>(item?.properties['_serviceData'])?.googleTagManager;
    }
  }
  const productProperties = gtmProduct?.google_tag_manager ? gtmProduct.google_tag_manager : gtmProduct;
  let variant = undefined;
  if (gtmProduct?.is_family && gtmProduct?.children) {
    const child = Object.values<{ Values: Array<string>; SKU: string }>(gtmProduct.children).find(
      child => child.SKU === item.sku
    );
    if (child?.Values && child?.Values[0]) variant = child.Values[0];
  }

  const ifANotSetThenB = (a: string, b: any) => {
    return a && a !== '(not set)' ? a : b;
  };

  let categories = ifANotSetThenB(productProperties?.category, undefined)?.split('/');

  const gtmWindowProduct = window?.gtm?.cartProducts?.find((product: Record<string, any>) => product.id === item.sku);
  if (!variant || !categories) {
    if (gtmWindowProduct) {
      if (!categories) categories = gtmWindowProduct.category?.split('/') || [];
      if (!variant) variant = gtmWindowProduct.variants?.[0]?.Value;
    }
  }

  if (!categories) categories = [];
  if (!variant) variant = '(unavailable)';

  const brand = ifANotSetThenB(
    categories[3] || categories[2] || categories[1] || categories[0] || item?.vendor,
    productProperties?.name
  );
  const name = ifANotSetThenB(productProperties?.name, item?.title);
  const saveAmount = gtmProduct?.pricing ? gtmProduct.pricing.saveAmount : gtmProduct?.saveAmount;

  return {
    discount: saveAmount,
    item_bestseller_flag: gtmProduct?.all_calculated_product_tags?.join(', ') || '(none)',
    item_brand: brand,
    item_category: categories[0] || item?.product_type,
    item_category2: categories[1],
    item_category3: categories[2],
    item_category4: categories[3],
    item_id: item.sku,
    item_list_name: item.properties?._itemListName,
    item_name: name,
    item_review_count: item.properties?._reviewCount,
    item_review_score: item.properties?._reviewScore,
    item_variant: variant,
    price: Number((item.line_price / 100).toFixed(2)),
    quantity: item.quantity,
    marketplace_product: item.properties?._marketplaceSellerId ? 'Y' : 'N',
    marketplace_seller_type: item.properties?._marketplaceSellerId ? '3P' : 'N/A',
    marketplace_seller_name: item.properties?._marketplaceSeller || 'N/A',
  };
};
